import { render, staticRenderFns } from "./VPNForm.vue?vue&type=template&id=6b4fcce3&scoped=true&"
import script from "./VPNForm.vue?vue&type=script&lang=js&"
export * from "./VPNForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4fcce3",
  null
  
)

export default component.exports